import { RouteObject } from "react-router-dom";
import DashboardPage from "./pages/DashboardPage";
import VerificationDetailPage from "./pages/VerificationDetailPage";

export const dashboardRoutes: RouteObject[] = [
  { index: true, element: <DashboardPage /> },
  { path: "verifications/:verificationId", element: <VerificationDetailPage /> },
];
